var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('p',{staticClass:"name"},[_vm._v("Copyright © StarrayTech Co., Limited ")]),_c('p',{staticClass:"name"},[_vm._v("Room A222, 3rd Floor, Phase 2, Hang Fung Industrial Building ")]),_c('p',{staticClass:"name"},[_vm._v("2G Hok Yuen Street, Hung Hom Kowloon, Hong Kong")])])
}]

export { render, staticRenderFns }